import App from "./App";
import { Toaster } from "@homy/ui";
import UpgradeModal from "@/features/memberships/components/UpgradeModal";
import { closeUpgradeModal } from "@/core/stores/upgradeModalStore";
import { IconThemeProvider } from "@homy/ui/icons";
import ModalErrorBoundary from "@/components/ModalErrorBoundary";

/**
 * The single catch-all data route's element: the app's declarative route tree
 * plus the global toaster, wrapped in the centralized bespoke SVG IconThemeProvider.
 */
export function Root() {
  return (
    <IconThemeProvider defaultVariant="spatial-bento-duotone">
      <App />
      <Toaster />
      <ModalErrorBoundary onClose={closeUpgradeModal}>
        <UpgradeModal />
      </ModalErrorBoundary>
    </IconThemeProvider>
  );
}

export default Root;

